import { render, staticRenderFns } from "./ViewProcessingOrder.vue?vue&type=template&id=a351fe8c&"
import script from "./ViewProcessingOrder.vue?vue&type=script&lang=js&"
export * from "./ViewProcessingOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports